import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import FormattedNumberWithCurrency from "components/formattedNumberWithCurrencies/formattedNumberWithCurrency";

import {getReferencePrice} from "views/oms/OrderList/utils/getReferencePrice";
import {hasCartPromotion} from "views/oms/OrderList/utils/hasCartPromotion";

import {black500, greyishBlue500} from "assets/jss/main";

import store from "store";

MobileTotal.propTypes = {
    total: PropTypes.number.isRequired,
    retailerTotal: PropTypes.number.isRequired,
    adjustments: PropTypes.array,
    lineItems: PropTypes.arrayOf(PropTypes.shape({
        retailerOriginalPrice: PropTypes.number,
        initialRecommendedPrice: PropTypes.number
    })).isRequired
};

const CouponIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.1997 7.22667C14.4597 7.22667 14.6663 7.02 14.6663 6.76V6.14C14.6663 3.40667 13.833 2.57333 11.0997 2.57333H4.89967C2.16634 2.57333 1.33301 3.40667 1.33301 6.14V6.45333C1.33301 6.71333 1.53967 6.92 1.79967 6.92C2.39967 6.92 2.88634 7.40667 2.88634 8.00667C2.88634 8.60667 2.39967 9.08667 1.79967 9.08667C1.53967 9.08667 1.33301 9.29333 1.33301 9.55333V9.86667C1.33301 12.6 2.16634 13.4333 4.89967 13.4333H11.0997C13.833 13.4333 14.6663 12.6 14.6663 9.86667C14.6663 9.60667 14.4597 9.4 14.1997 9.4C13.5997 9.4 13.113 8.91333 13.113 8.31333C13.113 7.71333 13.5997 7.22667 14.1997 7.22667ZM5.99967 5.92C6.36634 5.92 6.66634 6.22 6.66634 6.58667C6.66634 6.95333 6.37301 7.25333 5.99967 7.25333C5.63301 7.25333 5.33301 6.95333 5.33301 6.58667C5.33301 6.22 5.62634 5.92 5.99967 5.92ZM9.99967 10.5867C9.62634 10.5867 9.32634 10.2867 9.32634 9.92C9.32634 9.55333 9.62634 9.25333 9.99301 9.25333C10.3597 9.25333 10.6597 9.55333 10.6597 9.92C10.6597 10.2867 10.373 10.5867 9.99967 10.5867ZM10.5997 6.32L6.11301 10.8067C6.01301 10.9067 5.88634 10.9533 5.75967 10.9533C5.63301 10.9533 5.50634 10.9067 5.40634 10.8067C5.21301 10.6133 5.21301 10.2933 5.40634 10.1L9.89301 5.61333C10.0863 5.42 10.4063 5.42 10.5997 5.61333C10.793 5.80667 10.793 6.12667 10.5997 6.32Z" fill="#3C81FB"/>
    </svg>
);

function MobileTotal({total, retailerTotal, adjustments, lineItems}) {
    const currency = store.getState()?.currentOrganization?.retrieved?.currency;

    const referencePrice = getReferencePrice(lineItems);

    const haveReduction = retailerTotal < total;

    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                <span style={{color: black500, fontSize: '14px', fontWeight: 600}}>
                    <FormattedNumberWithCurrency value={haveReduction ? total : retailerTotal} currency={currency} />
                </span>
                {haveReduction && (
                    <span style={{color: greyishBlue500, fontSize: '14px', textDecoration: 'line-through'}}>
                        <FormattedNumberWithCurrency value={referencePrice} currency={currency} />
                    </span>
                )}
                {hasCartPromotion(adjustments) && <CouponIcon />}
            </div>
            <div style={{color: black500, fontSize: '14px'}}>
                <FormattedMessage id='oms.order.list.total.quantity' values={{count: lineItems.length}} />
            </div>
        </div>
    );
}

export default MobileTotal;
